<template>
  <div>
    <b-modal size="xl" button-size="md" ref="finder" hide-footer :id="this.id" :title="prefix + title">
      <Tipo-Local-Armazenamento-List :showCamposCustomizados="true" 
        @close="localArmazenamentoSelect" :prefix="prefix" />
    </b-modal>

    <lg-form-input-finder v-model="localObject" fieldDescription="descricao" :label="label"
      invalidFeedback="Tipo Local de  Armazenamento deve ser informado!" description="" @handleClean="localArmazenamentoSelect">
      <template #prepend>
        <b-button @click="show" class="btn-input-finder" pressed >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </div>
</template>
<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoLocalArmazenamentoList from "@/modules/cadastros/tipo-local-armazenamento/TipoLocalArmazenamentoList.vue";

export default {
  components: {
    LgFormInputFinder,
    TipoLocalArmazenamentoList,
  },

  props: {
    id: String,
    onDblClickLocalArmazenamentoList: Function,
    value: Object,
    label:{
      type:String,
      default: 'Tipo Local de Armazenamento:'
    },
    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tipo Local de Armazenamento",
    },

  },


  data() {
    return {
      localObject: this.value,
      localArmazenamento: "",
      fields: [
        {
          key: "nome",
          label: "Nome",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center col-1",
        },
      ],
    };
  },

  methods: {
   
    async show() {
      await this.$refs.finder.show();
      this.$bvModal.show(this.id);
    },

    async localArmazenamentoSelect(item) {
      this.localObject = item;
      this.$emit("close", item);
      await this.$bvModal.hide(this.id);
    },
  },
};
</script>
